var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderSearchWhite = function SvgHeaderSearchWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m14.807 13.747 7.693 7.692-1.06 1.061-7.693-7.693A7.44 7.44 0 0 1 9 16.5a7.45 7.45 0 0 1-5.303-2.197A7.45 7.45 0 0 1 1.5 9a7.45 7.45 0 0 1 2.197-5.303A7.45 7.45 0 0 1 9 1.5a7.45 7.45 0 0 1 5.303 2.197A7.45 7.45 0 0 1 16.5 9c0 1.75-.596 3.41-1.693 4.747m-10.05-.504A5.96 5.96 0 0 0 9 15c1.603 0 3.11-.624 4.243-1.757A5.96 5.96 0 0 0 15 9a5.96 5.96 0 0 0-1.757-4.243A5.96 5.96 0 0 0 9 3a5.96 5.96 0 0 0-4.243 1.757A5.96 5.96 0 0 0 3 9c0 1.603.624 3.11 1.757 4.243",
    clipRule: "evenodd"
  })));
};
export default SvgHeaderSearchWhite;